import { render, staticRenderFns } from "./SecondaryNav.vue?vue&type=template&id=c63e72d8&scoped=true&"
import script from "./SecondaryNav.vue?vue&type=script&lang=js&"
export * from "./SecondaryNav.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNav.vue?vue&type=style&index=0&id=c63e72d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63e72d8",
  null
  
)

export default component.exports